import { render, staticRenderFns } from "./CorporationMemberInvitationThanksModal.vue?vue&type=template&id=227b2aa3&scoped=true&"
import script from "./CorporationMemberInvitationThanksModal.vue?vue&type=script&lang=js&"
export * from "./CorporationMemberInvitationThanksModal.vue?vue&type=script&lang=js&"
import style0 from "./CorporationMemberInvitationThanksModal.vue?vue&type=style&index=0&id=227b2aa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227b2aa3",
  null
  
)

export default component.exports